import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isAsyncValueProvider } from '../../../../models/async-value';
import { AbstractField } from '../../models/field-configs/abstract-field';
import { FieldLabelConfig } from '../../models/field-configs/field-label-config.interface';

@Component({
  selector: 'app-form-info-message',
  templateUrl: './form-info-message.component.html',
  styleUrls: ['./form-info-message.component.scss'],
})
export class FormInfoMessageComponent extends AbstractField implements OnInit, OnDestroy {
  private _ngDestroyed$ = new Subject();

  // Config
  public config: FieldLabelConfig;
  public group: UntypedFormGroup;

  // View
  public text: string;
  public customColor = 'info-message';
  constructor() {
    super();
  }

  ngOnInit() {
    // Set text value
    if (this.config.text) {
      if (isAsyncValueProvider(this.config.text)) {
        this.config.text
          .getValue()
          .pipe(takeUntil(this._ngDestroyed$))
          .subscribe((text) => (this.text = text));
      } else if (typeof this.config.text === 'string') {
        this.text = this.config.text;
      }
    }
    this.customColor =
      !!this.config.iconColor && this.config.iconColor.toString().length > 0
        ? this.config.iconColor.toString()
        : 'info-message';
  }

  ngOnDestroy(): void {
    this._ngDestroyed$.next();
    this._ngDestroyed$.complete();
  }
}
